import React from 'react';
import { CircularProgress, Box } from '@mui/material';

const Loader: React.FC = () => (
  <Box
    display="flex"
    justifyContent="center"
    alignItems="center"
    height="100%"
    width="100%"
    position="absolute"
    top={0}
    left={0}
    bgcolor="white" 
    boxShadow="0 4px 12px rgba(0, 0, 0, 0.1)" 
    zIndex={1000}
  >
  <CircularProgress  sx={{ color: '#ED4B52' }} />
  </Box>
);

export default Loader;
